import React, { FC } from 'react';

import BundleTile from './BundleTile';
import {
    BulkAddProductsToSelectionListResponse,
    BulkAddProductsToShoppingCartResponse,
    BundleOut
} from '../../store/api';
import { BundlePreview } from './BundlePreview';
import { PriceTier } from '../../../models/PriceTier';

type Props = {
    readonly bundle: BundleOut;
    readonly onAddToCart: (
        bundleId: string,
        priceTier: PriceTier,
        performChecks: boolean
    ) => Promise<BulkAddProductsToShoppingCartResponse>;
    readonly onAddToList: (
        bundleId: string,
        listId: string,
        priceTier: PriceTier,
        performChecks: boolean
    ) => Promise<BulkAddProductsToSelectionListResponse>;
};

const BundleTileContainer: FC<Props> = ({ bundle, onAddToList, onAddToCart }) => {
    return (
        <div className="bndl-container">
            <BundleTile bundle={bundle} onAddToList={onAddToList} onAddToCart={onAddToCart} />
            <BundlePreview bundle={bundle} />
        </div>
    );
};

export default BundleTileContainer;
